import "./Roadmap.scss";

import ButtonOutline from "../../components/shared/ButtonOutline";

import RoadmapIcon from "../../assets/images/roadmap-icon.svg";
import { ArrowRight } from "iconsax-react";
import RoadmapBg from "../../assets/images/roadmap-bg.svg";

export default function Roadmap() {
	return (
		<div className="roadmap" id="roadmap">
			<div className="roadmap-content-wrapper content-wrapper-lg">
				<img
					className="decoration roadmap-bg"
					src={RoadmapBg}
					alt="Roadmap Background"
				/>
				<div className="decoration light light-1" />
				<div className="decoration light light-2" />

				<h3 className="roadmap-title" data-aos="zoom-in">
					Roadmap
				</h3>
				<div
					className="roadmap-desc"
					data-aos="fade-up"
					data-aos-delay="50"
				>
					Pioneering the future with intelligent,secure, and scalable
					Al agents and solutions that ignite innovation and
					accelerate transformation.
				</div>

				<div className="roadmap-cards-wrapper">
					<ul className="roadmap-cards">
						<li
							className="roadmap-card-item"
							data-aos="zoom-out-up"
							data-aos-delay="100"
						>
							<div className="roadmap-card" id="roadmap-card-1">
								<div className="roadmap-card-number">1</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Foundation & Building
								</div>
								<div className="roadmap-card-desc">
									In QI , we'll engage the community through
									social media, AMAs, and influencer
									partnerships, kickstart the development of
									Al agent features, launch the $IRIS token on
									UniSwap, and forge key strategic
									partnerships.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn" href="https://iriss-organization-2.gitbook.io/iris-ai/iris-roadmap/1st-quarter">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li
							className="roadmap-card-item"
							data-aos="zoom-out-right"
							data-aos-delay="300"
							data-aos-offset="0"
							data-aos-anchor="#roadmap-card-1"
						>
							<div className="roadmap-card">
								<div className="roadmap-card-number">2</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Beta Launch & Refinement
								</div>
								<div className="roadmap-card-desc">
									In the second quarter, we will release the
									beta version for limited user testing,
									gather feedback to refine platform features,
									run a marketing campaign to boost awareness
									and participation, and launch incentive
									programs to encourage community engagement.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn" href="https://iriss-organization-2.gitbook.io/iris-ai/iris-roadmap/2nd-quarter">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li
							className="roadmap-card-item"
							data-aos="zoom-out-up"
							data-aos-delay="500"
							data-aos-offset="0"
							data-aos-anchor="#roadmap-card-1"
						>
							<div className="roadmap-card">
								<div className="roadmap-card-number">3</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Full Launch & Expansion
								</div>
								<div className="roadmap-card-desc">
									In the third quarter, we will launch the
									full platform with advanced Al features,
									integrate the $IRIS token for platform
									access and governance, expand into new
									regions and sectors while targeting key
									users, and establish integrations with
									popular Web3 platforms and tools.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn" href="https://iriss-organization-2.gitbook.io/iris-ai/iris-roadmap/3rd-quarter">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>

						<li
							className="roadmap-card-item"
							data-aos="zoom-out-left"
							data-aos-delay="700"
							data-aos-offset="0"
							data-aos-anchor="#roadmap-card-1"
						>
							<div className="roadmap-card">
								<div className="roadmap-card-number">4</div>

								<div className="roadmap-card-icon">
									<img src={RoadmapIcon} alt="Roadmap Icon" />
								</div>
								<div className="roadmap-card-title">
									Governance & Long-Term Strategy
								</div>
								<div className="roadmap-card-desc">
									The 4th Quarter roadmap highlights a focused
									push toward deploying advanced features,
									strategic partnerships, and ecosystem
									improvements to elevate the functionality
									and user experience of Iris AI.
								</div>
								<div className="roadmap-card-btn">
									<ButtonOutline className="learn-more-btn" href="https://iriss-organization-2.gitbook.io/iris-ai/iris-roadmap/4th-quarter">
										Learn More
										<ArrowRight
											className="ms-2"
											size="16"
										/>
									</ButtonOutline>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}
